import * as React from 'react'
import { observer } from 'mobx-react'
import { breakpointStore } from '../../stores'
import { NavDesktop } from './desktop'
import { NavMobile } from './mobile'

@observer
export class Nav extends React.Component {
  render(): React.ReactNode {
    return (
      breakpointStore.breakpoint.above.sm
        ? <NavDesktop />
        : <NavMobile />
    )
  }
}
